import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function ChooseFileModal({ open, xmlHandles, onChoose, onCancel }) {
  //console.log('ConfirmModal', xmlHandles);
  if (!xmlHandles) return;
  var title = "Choose the XML file you want to display";
  if (xmlHandles.length === 0)
    title = "No files found";

  function handleCancel() {
    //console.log('handleCancel');
    onCancel();
  }

  function handleOnClose() {
    //console.log('handleOnClose');
    onCancel();
  }

  function selectFile(ix) {
    //console.log("file selected:", ix);
    onChoose(xmlHandles[ix]);
  }

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as='div'
        className='fixed inset-0 z-10 overflow-y-auto'
        onClose={handleOnClose}
      >
        <div className='min-h-screen px-4 text-center'>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0' />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className='inline-block h-screen align-middle'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 scale-95'
            enterTo='opacity-100 scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 scale-100'
            leaveTo='opacity-0 scale-95'
          >
            <div className='inline-block w-[700px]] p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-indigo-300 shadow-xl rounded-2xl'>
              <Dialog.Title
                as='h3'
                className='text-lg font-medium leading-6 text-black'
              >
                {title}
              </Dialog.Title>
              { (xmlHandles.length === 0) &&
                <div className='mt-2'>
                  <p className='text-sm font-semibold text-black'>
                    No XML files were found in the directory path you have chosen.<br/> 
                    Please select a directory that contains the file you want to display.<br/>
                  </p>
                </div>
              }
              { (xmlHandles.length > 0) &&
              <>
                <div className='mt-2'>
                  <p className='text-sm font-semibold text-black'>
                    There are more than one XML files in the path you have chosen.<br />
                    Please select the file you want from the list below or CANCEL and choose another path.<br />
                    <br />
                  </p>
                </div>
                <div>
                  <ul>
                  {
                    xmlHandles.map((x, xi) => {
                      return (
                        <li key={xi} 
                          className='hover: cursor-pointer hover:font-bold'
                          onClick={()=>{selectFile(xi)}}
                        >
                          {x.nestedPath}
                        </li>
                      )
                    })
                  }
                  </ul>
                </div>
              </>
              }
              <div className='mt-4 flex justify-between'>
                <button
                  type='button'
                  className='inline-flex justify-center px-4 py-2 text-sm font-medium text-black bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500'
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
